import React from 'react'
import Hero from '../components/Hero/Hero'
import Programs from '../components/Programs/Programs'
import Campus from '../components/Campus/Campus'
import About from '../components/About/About'
import Testimonials from '../components/Testimonials/Testimonials'
import Contact from '../components/Contact/Contact'
 

import Footer from '../components/Footer/Footer'
import ScrollToTop from '../components/Navbar/scroll';
const Home = () => {
  return (
    <div>
      <ScrollToTop />
      <Hero/>
      <Programs/>
      <About/>
      <Campus/>
      <Testimonials/>
      <Contact/>
      <Footer/>

      
    </div>
  )
}

export default Home
